export const COLORS = {
  title: "#2E6F8E",
  section: "#567D8C",
  text: "rgba(0,0,0,0.75)",
  switchOn: "#5C7F8A",
  switchOff: "#CFCFCF",
  bg: "#F5F5F5",
  nestedBg: "#F5F5F5",
  nestedBorder: "#F5F5F5",

  cardBg: "rgba(255,255,255,0.65)",
  selectedBg: "rgba(46,111,142,0.12)",
  selectedBorder: "#2E6F8E",
  hoverBg: "rgba(46,111,142,0.06)",
} as const;

export const tpPanelMotion = {
  initial: { opacity: 0, height: 0, y: -6 },
  animate: { opacity: 1, height: "auto", y: 0 },
  exit: { opacity: 0, height: 0, y: -6 },
} as const;
